export default __webpack_public_path__ + "static/media/cobrauc1.40034816.jpg";